import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FnGridColumn } from '../model/fn-grid-column';
import { FnGridRowHeader } from './../model/fn-grid.config';

@Component({
	selector: 'fn-grid-cell-group',
	templateUrl: 'fn-grid-cell-group.component.html',
	styleUrls: ['fn-grid-cell-group.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnGridCellGroupComponent {
	@Input() templateRef: any;
	@Input() columnArray: Array<FnGridColumn>;
	@Input() showAction: boolean;
	@Input() isPinTo: true;
	@Input() groupRowArray: Array<FnGridRowHeader>;
	@Input() groupRowHash: any;
	constructor() {}
	ngOnInit(): void {
		console.log(this.groupRowHash);
	}

	openClose(rowHeader: FnGridRowHeader) {
		rowHeader.isHidden = !rowHeader.isHidden;
	}
	isShowEmptyCell(column: FnGridColumn, index: number) {
		if (column.isHidden || column.isPinTo) {
			return false;
		}
		return this.showAction || index < this.columnArray.length - 2;
	}
}
